module.exports = {
	"articleTitle1": "Domino's will replace Bell's Pizza on Packard Street ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Pizza Bob's",
	"articleLink1": "https://www.michigandaily.com/section/news/dominos-replace-bells-pizza-packard",
	"articleLink2": "https://www.michigandaily.com/content/michigan-daily-pizza-challenge",
	"articleSnippet1": "Sep 5, 2016 ... For more than 30 years, Bell's Pizza stood at 700 Packard St. serving ... Other \npizza establishments near that intersection include Pizza Bob's, ...",
	"articleSnippet2": "Apr 14, 2004 ... Hello Faz Pizza, Anthony's Gourmet Pizza, DJ's Pizza, Mancino's, Marco's Pizza \nand Pizza Bob's. Unfortunately for Pizza Bob's, its driver was in ...",
	"foodRecommendations": [],
	"articleTitle2": "The Michigan Daily Pizza Challenge",
	"address": "814 S State St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.271454,
		"lng": -83.740793
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pizzabobs.json
// module id = 949
// module chunks = 0